import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { searchPlugin } from '@react-pdf-viewer/search';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/search/lib/styles/index.css';

const MyPdfViewer = () => {
  // Create an instance of the search plugin
  const searchPluginInstance = searchPlugin();

  return (
    <div style={{marginTop: '10px'}}>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <div
          style={{
            border: '1px solid rgba(0, 0, 0, 0.3)',
            // height: '750px',
            width: '500px'
          }}>
          {/* <Viewer
            fileUrl="https://www.clickdimensions.com/links/TestPDFfile.pdf"
          // plugins={[searchPluginInstance]}
          /> */}
          <div style={{ height: "620px" }}>
            <Viewer
              fileUrl={'/pdfs/white_paper4.pdf'}
            />
          </div>
        </div>
      </Worker >
    </div >
  );
};

export default MyPdfViewer;
